module.exports = __webpack_public_path__ + "img/AstroFrenz97.4725e7aa.jpg";